var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento reintegro...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.reintegro && _vm.reintegro != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs8: "" } },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass: "headline mb-0",
                                                  attrs: {
                                                    "data-test":
                                                      "reintegro-modello",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.reintegro.idModello
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                _vm._v("STAGIONE:"),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.reintegro.idStagione
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("COLORE:"),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.reintegro.idColore
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  "DATA/ORA INSERIMENTO: "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDateTime")(
                                                        _vm.reintegro
                                                          .dataOraInserimento
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "distinta",
                                                      params: {
                                                        id: _vm.reintegro
                                                          .idDistintaDPCStatica,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      "DETTAGLIO DISTINTA ASSOCIATA"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            color: "white",
                                            "margin-top": "10px",
                                          },
                                          attrs: {
                                            loading: _vm.csvButtonLoading,
                                            color: "green lighten-2",
                                          },
                                          on: {
                                            click: _vm.downloadCSVReintegro,
                                          },
                                        },
                                        [
                                          _vm._v(" Scarica CSV "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-download")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Righe reintegro")]),
                              ]),
                              _c("RigheReintegroList"),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v("OPPPSSS... Nessun dato da visualizzare."),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }